import { modoDaTabela, tabelaPadrao, type ModoTabelaDoItem } from '@/components/item-cadastro/tributos-excecao';
import { useTabelaPreco, useTabelasPreco } from './tabelas-preco';

/**
 * Sessao 51 (U2): modo da aba Tributacao do item. Le a tabela padrao da empresa (isDefault) e a vigencia vigente dela
 * (GET /tabelas-preco e GET /tabelas-preco/:id). O perfil so vem para quem tem custo.ver; a API decide o resto.
 */
export function useModoTabelaDoItem(hoje: string): ModoTabelaDoItem {
  const lista = useTabelasPreco();
  const padrao = tabelaPadrao(lista.data);
  const detalhe = useTabelaPreco(padrao?.id);
  return modoDaTabela({
    lista: lista.data,
    listaErro: lista.isError,
    detalhe: detalhe.data,
    detalheErro: detalhe.isError,
    hoje,
  });
}
